import React from "react";
import Settings from "./Settings";
import SpotCard from "./SpotCard";
import "./BestSpots.scss";

const labels = {
  filters: {
    da: "Filtre",
    en: "Filters",
    de: "Filter",
  },
  filteredSpots: {
    da: "Filterede fiskepladser",
    en: "Filtered fishing spots",
    de: "Gefilterte Angelplätze",
  },
  distance: {
    da: "Afstand",
    en: "Distance",
    de: "Entfernung",
  },
  coastType: {
    da: "Kysttype",
    en: "Coastal type",
    de: "Küstentyp",
  },
  fishTypes: {
    da: "Fiskearter",
    en: "Fish species",
    de: "Fischarten",
  },
  locationError: {
    da: "For at se denne liste skal du tillade lokation",
    en: "Too see this list, you have to allow location services",
    de: "Um diese Liste anzuzeigen, erlauben Sie den Standort",
  },
};

/*
 * This component displays the best spots as content of the rightside sidebar
 */

const BestSpots = (props) => {
  return (
    <div className="bestSpots">
      <h3>{labels.filters[props.language]}</h3>
      <Settings
        settings={props.settings}
        coastTypes={props.coastCategories ? props.coastCategories : []}
        fishTypes={props.fishCategories ? props.fishCategories : []}
        newSettings={props.newSettings}
        futureMode={props.futureMode}
        language={props.language}
      />

      <h3 id="fiskePladserHeadline">{labels.filteredSpots[props.language]}</h3>

      <div>
        <div className="sortingBar">
          <span>
            {labels.distance[props.language]}{" "}
            <i className="fas fa-angle-down" />
          </span>
          <span>{labels.coastType[props.language]}</span>
          <span>{labels.fishTypes[props.language]}</span>
        </div>
        <div>
          {props.spots &&
            props.spots.map((s, i) => (
              <SpotCard
                key={i}
                data={s}
                openSpot={props.openSpot}
                language={props.language}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default BestSpots;
